import React, { Fragment } from 'react';
import { ReactComponent as Header } from '../../img/six.svg.svg';
import { ReactComponent as Explore } from '../../img/theer.svg.svg';
import { ReactComponent as Dark } from '../../img/happy-music.svg';
import { ReactComponent as Share } from '../../img/fore.svg.svg';

function Welcome() {
  return (
    <Fragment>
      <section id='body-welcome'>
        <div className='my-home-section'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <Header className='img-fluid mb-3' style={headerStyle} />
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <div className='my-form-section text-center'>
                  <h1>
                    <i className='fab fa-github my-github'></i>
                  </h1>
                  <h3 className='display-4'>
                    <b>Git</b>hub Search Users
                  </h3>
                  <p>
                    You can find people in this app they are users in Github
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <seaction id='explore-head-section'>
          <div className='container'>
            <div className='row'>
              <div className='col text-center py-5'>
                <h1 className='display-4'>Description</h1>
                <p className='lead'>
                  The content of this is to website enable the use of Github
                  data on the site users search and show information about them
                  if you want to read click
                </p>
                <a href='/about' className='btn btn-outline-secondary'>
                  Find out More
                </a>
              </div>
            </div>
          </div>
        </seaction>
        <section id='explore-section' className='bg-light text-muted py-5'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6'>
                <Explore className='img-fluid mb-3' />
              </div>
              <div className='col-md-6'>
                <h3>Responsive and Grid</h3>
                <p>
                  This simple site is one of the goals of ease of use and
                  enabling the user to operate it on phones, tablets and
                  computers :{' '}
                </p>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You will not find any difference between using them on
                    phones or computers, as if they were made for both phones,
                    and it supports even the latest newer phones
                  </div>
                </div>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You are suffering from slow internet only. Don't be afraid
                    of this, because it is free of many tools, and it will not
                    delay downloading
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id='create-head-section' className='create-head-section'>
          <div className='container'>
            <div className='row'>
              <div className='col text-center py-5'>
                <h1 className='display-4'>Create</h1>
                <p className='lead'>
                  It was created with very simple things Bootstrap and React and
                  is based on Github data
                </p>
                <a href='https://github.com' className='btn btn-outline-light'>
                  Find out More
                </a>
              </div>
            </div>
          </div>
        </section>
        <section id='create-section' className='py-5'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6 order-2'>
                <Dark className='img-fluid mb-3' />
              </div>
              <div className='col-md-6 order-1'>
                <h3>Create &amp; Content</h3>
                <p>
                  This site can meet the needs of the developer or any worker
                  who makes his work easier for such a site has a display of his
                  work for his ease of use
                </p>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You are a lawyer and you need a special site that is easy to
                    use and easy to reach for customers. This is just for you
                  </div>
                </div>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You are a beginner web developer who needs anything that
                    helps you show off your skills. This can help you
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id='share-head-section' className='share-head-section'>
          <div className='container'>
            <div className='row'>
              <div className='col text-center py-5'>
                <h1 className='display-4'>Share</h1>
                <p className='lead'>
                  We'll talk about what Github does. You can see it in more
                  depth just follow the path
                </p>
                <a href='https://github.com' className='btn btn-outline-light'>
                  Find out More
                </a>
              </div>
            </div>
          </div>
        </section>
        <section id='share-section' className='bg-light text-muted py-5'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6'>
                <Share className='img-fluid mb-3' />
              </div>
              <div className='col-md-6'>
                <h3>Share Your Content</h3>
                <p>
                  You are a developer and you are looking to publish your
                  business. Github can be hired to help you a lot
                </p>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You can receive codes safely and with great experience, and
                    you can also find great content
                  </div>
                </div>
                <div className='d-flex'>
                  <div className='p-4 align-self-start'>
                    <i className='fas fa-check fa-2x' />
                  </div>
                  <div className='p-4 align-self-start'>
                    You can work with it, deliver your customer's request, or
                    easily receive your order from the customer
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Fragment>
  );
}

const headerStyle = {
  minHeight: '689px'
};

export default Welcome;
